import { ArrowPathIcon, GlobeAsiaAustraliaIcon } from "@heroicons/react/24/outline";
import { getSearchArticles, getLatestArticles } from "../services/api";
import PlaceCard from "./placeCard";
import { useEffect, useState } from "react";
import { useDebouncedCallback } from "use-debounce";
import type { ICard } from "../interfaces/interfaces";
import trackClick from "../services/analytics";

export default function Discover() {

  const [places, setPlaces] = useState<ICard[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [queryString, setQueryString] = useState<string>('');
  //const [totalResults, setTotalResults] = useState<number>(0);
  const limit = 20;
  const [offset, setOffset] = useState<number>(0);

  useEffect(() => {
    setIsLoading(true);
    getLatestArticles().then((data) => {
      setPlaces(data.results);
      setIsLoading(false);
    });
  }, []);

  const updateSearchDestination = (query: string) => {
    setIsLoading(true);
    setQueryString(query);
    trackClick('discover', 'Search')
    setOffset(0);
    getSearchArticles(query, limit, 0).then((data) => {
      console.log(data)
      setPlaces(data.results);
      //setTotalResults(data.count);
      setIsLoading(false);
      setOffset(limit);
    });
  }

  const getNextArticles = () => {
    setIsLoading(true);
    getSearchArticles(queryString, limit, offset).then((data) => {
      setPlaces(data.results);
      setIsLoading(false);
      setOffset(offset + limit);
    });
  }
  
  const debounced = useDebouncedCallback(
    (value) => {
      if (value.length === 0) {
        getNextArticles()
      } else {
        updateSearchDestination(value);
      }
    },
    // delay in ms
    750
  );
  
  return (
    <div>
        <div className="bg-white mx-auto relative container">
            <div className="">
                <div>
                <section className="bg-gradient-to-r from-[#EFC7E6] to-[#95ADDD] overflow-hidden relative rounded-lg">
                    <div className="bg-fixed absolute blur-[8px] min-h-full min-w-full " 
                        style={{
                            backgroundImage: `url('/assets/images/backgrounds/world-map-hex.svg')`}}
                        >
                    </div>
                    <section className="relative pb-4 ">
                        <div className="relative container px-4 mx-auto text-center">
                            <div className="text-7xl font-extrabold my-20">
                                <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#EFC7E6] from-20% to-[#522AC4]">
                                    Be Inspired
                                </span>
                            </div>
                            {/* <h2 className="mt-4 mb-8 lg:mb-12 text-white text-4xl lg:text-6xl font-semibold">
                                <span className="bg-clip-text text-transparent bg-gradient-to-r from-explraBlue-primary to-violet-500">
                                    
                                </span>
                            </h2> */}
                            <p className="max-w-2xl mx-auto pb-24 lg:mb-12 text-[#552ebf] text-3xl font-semibold">
                                Discover articles and blogs from around the web related to your next trip.
                            </p>
                        </div>
                        
                    </section>
                </section>
        
            </div>
        </div>
        <section className="relative -mt-20 z-20">
            <div className="relative container mx-auto max-w-3xl">
                <div className="mx-6 bg-white rounded-md shadow-lg py-6">
                    <div className="p-4">
                        <div className="md:rounded-full md:flex mx-4 md:mx-auto">
                            <div className="relative bg-transparent border-transparent md:inline-block w-full">
                                <label className='flex items-center mb-2'>
                                    {/* <span className="pointer-events-none bg-transparent border-transparent z-10">
                                        <GlobeAsiaAustraliaIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                    </span> */}
                                    {/* <span className='ml-2 font-medium'>
                                        Destination
                                    </span> */}
                                </label>
                                <div className='ml-0 md:mx-7'>
                                    <input 
                                      onChange={(e) => debounced(e.target.value)}
                                      type="text" 
                                      className="w-full" 
                                      placeholder="Solo travel in Spain" 
                                    />
                                    <span className="text-sm italic">
                                        Enter the country or city you are interested in to get relevant & up-to-date articles and blogs.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>   
        <section className="relative py-20">
        <div className="container px-4 mx-auto flex flex-wrap -m-3">
            <div className="w-full">
                <h1 className="inline-block text-2xl font-semibold font-heading">Recent Articles</h1>
                {/* <a className="font-medium text-sm text-explraRed underline hover:no-underline" href={urlLink}>View more</a> */}
                <p className="mb-12 text-gray-500 leading-relaxed">Read up about the interesting travels from globe trotters and be inspired with our curated list of fresh new content from travellers blogs.</p>
            </div>
            {/* TODO: Pagination */}
            {isLoading ?
              <div className="flex-none mx-auto text-center">
                <ArrowPathIcon className='h-12 w-12 animate-spin text-gray-300' />
              </div>
              :
              <div>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 grid-flow-row gap-4">
                  {places.length > 0 ?
                    (places.map(place => {
                    return (
                        <PlaceCard 
                          key={place.id} 
                          item={place} 
                        />
                    )
                  }))
                  :
                    <div>No results, try another phrase.</div>
                  }
                </div>
                {queryString.length > 0 &&
                <div className="flex-none mx-auto text-center mt-12">
                  <button onClick={getNextArticles} className="rounded-xl border-coolGray-200 border px-8 py-2 inline-block hover:bg-coolGray-50">Load More</button>
                </div>
                }
              </div>
          }
          </div>
        </section>
      </div>      
    </div>
  )
}